import React from "react";
import BreadCrumb from "@/components/BreadCrumb";
import Map from "@/components/Maps";
import useFetchApi from "@/api/hooks/useFetchApi";
import { Formik } from "formik";
import * as yup from "yup";

const ContactUs = () => {
    const { data, isLoading } = useFetchApi({
        url: "/v1/gp/677e77112d638d2cfc867966/tr/find",
        service: "CMS_PROC"
    });

    return (
        <>
            <BreadCrumb title="İletişim" parent="" child="İletişim" />
            <section className="ls section_padding_top_100 section_padding_bottom_75">
                <div className="container">
                    {data && data.results.map((element: any, index: number) => (
                        <Map
                            key={`contact-us-maps-${index}`}
                            data={element}
                            isLoading={isLoading}
                        />
                    ))}
                </div>
            </section>
        </>
    );
};

export default ContactUs;